import JobFilterContainer from "../../../components/job/other/JobFilter";

const JobFilter = () => {
  return <JobFilterContainer />;
};

export default JobFilter;
